import { registerPlugin } from '@capacitor/core';
const Calendar = registerPlugin('Calendar', {
    web: () => import('./web').then((m) => new m.CalendarWeb()),
});
export * from './definitions';
export { Calendar };
//# sourceMappingURL=index.js.map